import { UniteTypeRequisiteType } from '~/generated/payoutBackend/model';

export const requisiteTypes = Object.values(UniteTypeRequisiteType)
    .filter((c) => c !== UniteTypeRequisiteType.TYPE_UNSPECIFIED)
    .map((value) => ({
        value,
        label: value.replace('TYPE', '').replaceAll('_', ' '),
    }));
